import React from 'react';
import {useEffect, useState} from "react";
import {setLoadingStateDispatch, useLoadingDispatcher} from "../../context/LoadingContext";
import {
    Box,
    Button,
    FormControl,
    Grid,
    InputAdornment,
    InputLabel,
    Select,
    TextField,
    Typography
} from "@material-ui/core";
import CustomTable from "../../component/customTable/CustomTable";
import {Pagination} from "@material-ui/lab";
import CashGroupInfo from "../CashGroupInfo/CashGroupInfo";
import searchIcon from "../../assets/images/search-normal.svg"
import {useSnackbarDispatcher} from "../../context/SnackBarContext";
import {useAuthState} from "../../context/AuthContext";
import {CashGroupService} from "./CashGroupService";
import {convertCurrencyFormat} from "../../utils/numberConvertor";
import moment from "jalali-moment";
import {ServerErrorHandler} from "../../service/httpClient/ServerErrorHandler";
import DefaultDialogPage, {DialogSize} from "../../component/defaultDialogPage/DefaultDialogPage";

let page = 0
const CashGroups = () => {


    const loading = useLoadingDispatcher()
    const snackbar = useSnackbarDispatcher()
    const {token, fundID} = useAuthState()

    const service = new CashGroupService(fundID, token, snackbar, loading)


    let filterSearchText = ""
    const [filterText, setFilterText] = useState("");
    const [filterSelectedValue, setFilterSelectedValue] = useState(1);


    const [pageCount, setPageCount] = useState(0);
    const [itemCount, setItemCount] = useState(0);

    const [cashGroupsList, setCashGroupsList] = useState([]);

    const [needRefresh, setNeedRefresh] = useState(false);

    const [selectedItemId, setSelectedItemId] = useState(-1)

    const handleChange = (event, value) => {
        page = value - 1
        getListDataFromServer()
    };

    useEffect(() => {
        if (typeof service !== 'undefined') {
            getListDataFromServer()
        }
    }, [])


    function getListDataFromServer() {
        loading(setLoadingStateDispatch(true))

        service.getCashGroupsList(
            fundID,
            page,
            filterSelectedValue === 2 ? filterSearchText : "",
            filterSelectedValue === 1 ? filterSearchText : ""
        ).then(response => {

            setGroupsListData(response)
            loading(setLoadingStateDispatch(false))
        }).catch(reason => {
            ServerErrorHandler(reason, "خطا در دریافت اطلاعات گروه ها", snackbar, loading)
        })
    }


    function setGroupsListData(groupData) {
        setItemCount(groupData.numberOfItems)
        setPageCount(groupData.totalPage)
        setCashGroupsList([])

        groupData.data.map((item, index) => {
            const teamLeader = `${item.groupLeader ? item.groupLeader.firstName : ""} ${item.groupLeader ? item.groupLeader.lastName : ""}`
            setCashGroupsList((prevState => [...prevState,
                prepareGroupsJsonList(
                    item.id,
                    (page * 20) + index + 1,
                    item.code,
                    item.name,
                    item.summationOfDepositAccountsBalance,
                    item.numberOfDepositAccounts,
                    item.summationOfLoans,
                    item.numberOfLoans,
                    item.numberOfMembers,
                    item.createdAt,
                    teamLeader.length > 2 ? teamLeader : "نامشخص",
                    item.enabled
                )
            ]))
        })
    }


    const showEventsContent = (rowId) => {
        setSelectedItemId(rowId)
        handleOpenDialogState(true);
    }


    const [dialogOpenState, setDialogOpenState] = useState(false);

    function handleOpenDialogState() {
        setDialogOpenState(true)
    }

    function handleCloseDialogState() {
        setDialogOpenState(false)
        if (needRefresh) {
            page = 0
            setNeedRefresh(false)
            getListDataFromServer()
        }
        setSelectedItemId(-1)
    }

    return (
        <>
            {
                <DefaultDialogPage
                    onClose={handleCloseDialogState}
                    open={dialogOpenState}
                    pageTitle={selectedItemId < 0 ? "افزودن گروه جدید" : "جزئیات گروه"}
                    dialogSize={selectedItemId < 0 ? DialogSize.WRAP_CONTENT : DialogSize.LARGE}
                >
                    <CashGroupInfo
                        selectedItemId={selectedItemId}
                        needRefresh={setNeedRefresh}
                    />
                </DefaultDialogPage>
            }

            <section className='pageContainer' style={{overflowY: 'hidden'}}>

                <Box className="d-flex flex-row w-100"
                     sx={{
                         margin: '1rem 0 1.2rem 0',
                         justifyContent: 'center',
                         alignContent: 'center',
                         alignItems: 'center'
                     }}>
                    <section className='d-flex flex-column flex-nowrap flex-grow-1'
                             style={{alignItems: 'baseline'}}>
                        <Typography variant={"h5"}>
                            گروه ها
                        </Typography>
                        {itemCount > 0 ?
                            <Typography style={{margin: "8px 8px 0 8px"}} variant={"caption"}>
                                {" " + itemCount + " گروه ثبت شده "}
                            </Typography> :
                            ''}
                    </section>
                    <Button
                        variant='contained'
                        onClick={() => {
                            setSelectedItemId(-1)
                            handleOpenDialogState();
                        }}
                        // startIcon={<DeleteIcon/>}
                    >
                        افزودن گروه جدید
                    </Button>
                </Box>
                <Box className="d-flex flex-row w-100"
                     sx={{
                         margin: '0 0 1.2rem 0',
                         justifyContent: 'start',
                         alignContent: 'start',
                         alignItems: 'start'
                     }}>
                    <Grid sm={12} md={8} lg={8} xl={8} className='modalTextFieldContainer'>
                        <TextField
                            value={filterText}
                            onChange={e => {
                                setFilterText(e.target.value)
                                filterSearchText = e.target.value
                                getListDataFromServer()
                            }}
                            className='w-100'
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <img src={searchIcon} alt=""/>
                                    </InputAdornment>
                                ),
                            }}
                            variant="outlined" label="جستجو"
                            placeholder="عبارت مورد نظر را وارد نمایید..."/>
                    </Grid>
                    <Grid sm={12} md={8} lg={4} xl={4} className='modalTextFieldContainer'>
                        <FormControl variant="outlined" className="w-100">
                            <InputLabel htmlFor="filled-age-native-simple">جستجو بر اساس</InputLabel>
                            <Select label="جستجو بر اساس"
                                    value={filterSelectedValue}
                                    onChange={e => {
                                        setFilterSelectedValue(e.target.value)
                                        getListDataFromServer()
                                    }}
                            >
                                <option value={1}>کد گروه</option>
                                <option value={2}>نام گروه</option>
                            </Select>
                        </FormControl>
                    </Grid>

                </Box>


                <CustomTable
                    header={columns}
                    data={cashGroupsList}
                    rowClicked={showEventsContent}
                />
                <Box className="paginationContainer">
                    <Pagination
                        count={pageCount}
                        color="primary"
                        onChange={handleChange}
                        showFirstButton showLastButton/>
                </Box>
            </section>
        </>
    )

}

export default CashGroups;


const columns = [
        {
            id: 'number',
            label: '#',
            align: 'right',
        },
        {
            id: 'code',
            label: 'کد',
            align: 'right',
        },
        {
            id: 'name',
            label: 'نام',
            align: 'right',
        },
        {
            id: 'cash',
            label: 'مجموع پس انداز (ریال)',
            align: 'right',
        },
        {
            id: 'numberOfLoans',
            label: 'تعداد وام ها',
            align: 'right',
        },
        {
            id: 'loanAmount',
            label: 'مجموع وام ها (ریال)',
            align: 'right',
        },
        {
            id: 'userCount',
            label: 'اعضا',
            align: 'right',
        },
        {
            id: 'numberOfDepositAccounts',
            label: 'تعداد حساب ها',
            align: 'right',
        },
        {
            id: 'createdDate',
            label: 'تاریخ ساخت',
            align: 'right',
        },
        {
            id: 'teamLeader',
            label: 'سرگروه',
            align: 'right',
        },
        {
            id: 'state',
            label: 'وضعیت',
            align: 'right',
        },
    ]
;


function prepareGroupsJsonList(
    id, itemID, code, name, inventory, numberOfDepositAccounts,
    summationOfLoans, numberOfLoans, numberOfMembers, createdDate, teamLeader, enabled) {
    return {
        id: id,
        number: itemID,
        code: code,
        name: name,
        loanAmount: summationOfLoans ? convertCurrencyFormat(summationOfLoans) : "0",
        numberOfLoans: numberOfLoans ? convertCurrencyFormat(numberOfLoans) : "0",
        numberOfDepositAccounts: numberOfDepositAccounts ? convertCurrencyFormat(numberOfDepositAccounts) : "0",
        userCount: numberOfMembers ? convertCurrencyFormat(numberOfMembers) : "0",
        cash: convertCurrencyFormat(inventory),
        createdDate: moment(createdDate, 'YYYY-M-D')
            .locale('fa')
            .format('YYYY/M/D'),
        teamLeader: teamLeader,
        state: enabled ?
            <span className="bg_active_state">فعال</span> :
            <span className="bg_deActive_state">غیرفعال</span>,
    };
}
